import { render, staticRenderFns } from "./PopAnalysisResult.vue?vue&type=template&id=6c9def7a&lang=pug"
import script from "./PopAnalysisResult.vue?vue&type=script&lang=js"
export * from "./PopAnalysisResult.vue?vue&type=script&lang=js"
import style0 from "./PopAnalysisResult.vue?vue&type=style&index=0&id=6c9def7a&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports